module.exports = __webpack_public_path__ + "img/frs3.b292fe23.jpg";